// dateText/dateTextLanguages.js — words the date text recognition knows, one entry per language (plan
// bugfix_2026-10-12_chef-sammelliste, phase datum-sprachen). Pure data; a new language or a missing word is one line.
//
// Keys = language codes of the Topothek (table language, topoLanguage). The caller chooses which languages count —
// in documents.js the menu language plus German.
//
// months: one list per month, position + 1 = month number; full name, short forms, variants. Written naturally —
// case, accents and a trailing dot do not matter when comparing ("Sept." = "sept"). A word needs 3–10 letters.
// The same word may stand in several languages only for the same month (checked when the lookup is built).
//
// approximate: words that make a date vague ("ca. 1920", "um März 1920"); the range then widens by one unit (year ±1,
// month ±1, day ±1). Compared like the months; any length.
//
// Further Topothek languages after asking the boss (plan, phase spaeter).

export const DATE_TEXT_LANGUAGES = Object.freeze({
    de: {
        months: [
            ['januar', 'jänner', 'jänn', 'jän', 'jan'],
            ['februar', 'feber', 'febr', 'feb'],
            ['märz', 'maerz', 'mär', 'mrz'],
            ['april', 'apr'],
            ['mai'],
            ['juni', 'jun'],
            ['juli', 'jul'],
            ['august', 'aug'],
            ['september', 'sept', 'sep'],
            ['oktober', 'okt'],
            ['november', 'nov'],
            ['dezember', 'dez'],
        ],
        approximate: ['ungefähr', 'ungefaehr', 'ca', 'circa', 'zirka', 'etwa', 'um', 'gegen'],
    },
    en: {
        months: [
            ['january', 'jan'],
            ['february', 'feb'],
            ['march', 'mar'],
            ['april', 'apr'],
            ['may'],
            ['june', 'jun'],
            ['july', 'jul'],
            ['august', 'aug'],
            ['september', 'sept', 'sep'],
            ['october', 'oct'],
            ['november', 'nov'],
            ['december', 'dec'],
        ],
        approximate: ['about', 'around', 'approx', 'approximately', 'circa', 'ca', 'c'],
    },
    es: {
        months: [
            ['enero', 'ene'],
            ['febrero', 'feb'],
            ['marzo', 'mar'],
            ['abril', 'abr'],
            ['mayo', 'may'],
            ['junio', 'jun'],
            ['julio', 'jul'],
            ['agosto', 'ago'],
            ['septiembre', 'setiembre', 'sept', 'sep', 'set'],
            ['octubre', 'oct'],
            ['noviembre', 'nov'],
            ['diciembre', 'dic'],
        ],
        approximate: ['hacia', 'aprox', 'aproximadamente', 'circa', 'ca', 'sobre'],
    },
});
